/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'refresh': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M20 10c0 5.523-4.477 10-10 10-2.804 0-5.275-1.183-7-3.27V20H1v-7h7v2H4.193c1.36 1.921 3.413 3 5.807 3a8 8 0 008-8h2zM19 0v7h-7V5h3.807C14.447 3.079 12.394 2 10 2a8 8 0 00-8 8H0C0 4.477 4.477 0 10 0c2.804 0 5.275 1.183 7 3.27V0h2z" _fill="#000" fill-rule="evenodd"/>'
  }
})
